module.exports = __webpack_public_path__ + "media/images/arrow-a4e3bfcb78db89133b81cb1715755b2f.svg";